import { Node } from '@craftjs/core';

import type { BlockType } from './blockEditor.types';
import { BlockEditorCanvasContainer } from './BlockEditorCanvasContainer/BlockEditorCanvasContainer';
import { BlockEditorRoot } from './BlockEditorRoot/BlockEditorRoot';
import { ListItemsSection } from './ListItemsSection/ListItemsSection';
import { TwoColumnLayout } from './TwoColumnLayout/TwoColumnLayout';

export const BLOCK_EDITOR_RESOLVER = {
  BlockEditorRoot: BlockEditorRoot,
  BlockEditorCanvas: BlockEditorCanvasContainer,
  ListItemsSection: ListItemsSection,
  TwoColumnLayout: TwoColumnLayout,
};

/**
 * Creates a Craft.js `canMoveIn` rule that restricts which block types
 * can be dropped into a canvas container.
 *
 * The allowed types are read from `self.data.custom.allowedTypes` and can
 * match either the block's displayName or resolver name.
 *
 * @returns A canMoveIn rule function for use in Craft.js component config
 */
export function createAllowedTypesRule() {
  return (incomingNodes: Node[], self: Node): boolean => {
    const { allowedTypes } = self.data.custom as {
      allowedTypes?: BlockType[];
    };

    // If no allowedTypes are specified, allow everything
    if (!allowedTypes) {
      return true;
    }

    return incomingNodes.every((node) => {
      const { displayName } = node.data;
      return allowedTypes.includes(displayName);
    });
  };
}
